import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import BetTableMogambo from "../../casinoComponents/betTableMogambo";
import VideoBox from "../../casinoComponents/videoBox";
import MogamboCardsOverlay from "../../casinoComponents/videoBox/overlays/MogamboCardsOverlay";
import MogamboVideoTitle from "../../casinoComponents/videoBox/overlays/MogamboVideoTitle";
import ResultMogambo from "../resultui/resultMogambo/ResultMogambo";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import "../../../styles/games/mogambo.css";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatBetNation, formatBetOdds } from "../../../utils/casinoMyBets";


export default function Mogambo() {
  const [gameData, setGameData] = useState(null);
  const [iframeSrc, setIframeSrc] = useState("");
  const [tableData, setTableData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "mogambo";

  useEffect(() => {
    setIframeSrc(
      `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`
    );
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails("mogambo");
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };
    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [pathname, gameName]);

  useEffect(() => {
    const subData = gameData?.data?.data?.sub ?? gameData?.data?.sub ?? [];
    setTableData(subData);
  }, [gameData]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id ?? user?.id ?? user?.staff_id ?? user?.owner_id;
      const matchId =
        gameData?.data?.data?.mid?.toString() ??
        gameData?.data?.mid?.toString() ??
        gameData?.mid?.toString();
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response?.success && response?.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const name = item.team_name || item.selection || item.player_name || "";
            const amount = parseFloat(item.exposure_amount) || 0;
            if (name) {
              exposureMap[name] = amount;
              exposureMap[name.trim()] = amount;
              exposureMap[name.toLowerCase().trim()] = amount;
            }
          });
          // 3 Card Total is one ladder over the total (rows "TOTAL runs 4" … "TOTAL runs 38"):
          // its cell shows the panel's worst of them.
          const ladder = response.data.filter((item) => /^TOTAL runs \d+$/.test(item.team_name || ""));
          if (ladder.length) exposureMap["3 Card Total"] = Math.min(...ladder.map((item) => parseFloat(item.exposure_amount) || 0));
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [gameData]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username ?? bet.userName ?? "-",
          matchedBet:
            bet.matchedBet ?? bet.nation ?? bet.selection ?? bet.player_name ?? "-",
          selection:
            bet.selection ?? bet.player_name ?? bet.matchedBet ?? "",
          player_name: bet.player_name ?? "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype:
            bet.gametype ??
            bet.game_type ??
            (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type ?? null,
          exposer: parseFloat(bet.exposer ?? bet.exposure_amount ?? "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [gameName]);

  useEffect(() => {
    const matchId =
      gameData?.data?.data?.mid?.toString() ??
      gameData?.data?.mid?.toString() ??
      gameData?.mid?.toString();
    if (matchId) {
      fetchExposure();
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => clearInterval(exposureInterval);
    }
  }, [gameData, fetchExposure]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const mid = gameData?.data?.data?.mid ?? gameData?.data?.mid ?? gameData?.mid;
  const remark = gameData?.data?.data?.remark ?? gameData?.data?.remark ?? "";
  // 3 Card Total bets read "3 Card Total-90" with the line as the rate
  const formatNation = (nat, bet) => formatBetNation("mogambo", nat, bet);
  const formatRate = (bet) => formatBetOdds("mogambo", bet, bet.odds ?? bet.userrate);

  // Reference markup: .casino-table.mogambo.teenpatti2cards has no .game-header — the title and
  // round id sit in the video (.casino-video-title = MogamboVideoTitle, VideoBox titleNode).
  return (
    <CasinoTableLayout
      tableClass="mogambo teenpatti2cards"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} formatNation={formatNation} formatRate={formatRate} />}
    >
      <VideoBox
        iframeSrc={iframeSrc}
        timerValue={gameData?.data?.data?.lt}
        gameType={null}
        titleNode={<MogamboVideoTitle roundId={mid} />}
        cardsOverlay={<MogamboCardsOverlay card={gameData?.data?.data?.card} />}
      />
      {mid ? (
        <div className="casino-detail">
          <BetTableMogambo
            data={tableData}
            onBetClick={handleBetClick}
            exposures={exposures}
          />{" "}
          {remark !== "" && (
            <div className="casino-remark mt-3">
              <div className="remark-icon">
                <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
              </div>{" "}
              <marquee>{remark}</marquee>
            </div>
          )}{" "}
          <CasinoLastResult
            gameType="mogambo"
            resultComponent={<ResultMogambo roundId={mid} />}
          />
        </div>
      ) : null}
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatNation}
        formatRate={formatRate}
      />
    </CasinoTableLayout>
  );
}
